//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";

const emptyCompany = () => ({
    code: "",
    name: "",
    company_address: "",
    company_address2: "",
    subdistrict: "",
    district: "",
    province: "",
    postcode: "",
    country: "",
    company_branch: "",
    company_email: "",
    company_tel: "",
    inv_company_name: "",
    inv_company_name_th: "",
    inv_company_address: "",
    inv_company_address2: "",
    inv_subdistrict: "",
    inv_district: "",
    inv_province: "",
    inv_postcode: "",
    inv_country: "",
    inv_company_branch: "",
    inv_company_email: "",
    inv_company_tel: "",
    inv_tax_id: "",
    status: "ACTIVE",
    module: "Employee",
    id_prefix: "",
    running_year: new Date().getFullYear().toString().slice(-2),
    running_len: 1,
    running_next: 1,
    doc_status: 0,
});

// รายชื่อจังหวัด (ใช้ใน dropdown Province, พิมพ์ค่าอื่นเองได้)
const PROVINCES = [
    "Bangkok", "Amnat Charoen", "Ang Thong", "Bueng Kan", "Buriram", "Chachoengsao", "Chai Nat",
    "Chaiyaphum", "Chanthaburi", "Chiang Mai", "Chiang Rai", "Chonburi", "Chumphon", "Kalasin",
    "Kamphaeng Phet", "Kanchanaburi", "Khon Kaen", "Krabi", "Lampang", "Lamphun", "Loei", "Lopburi",
    "Mae Hong Son", "Maha Sarakham", "Mukdahan", "Nakhon Nayok", "Nakhon Pathom", "Nakhon Phanom",
    "Nakhon Ratchasima", "Nakhon Sawan", "Nakhon Si Thammarat", "Nan", "Narathiwat", "Nong Bua Lamphu",
    "Nong Khai", "Nonthaburi", "Pathum Thani", "Pattani", "Phang Nga", "Phatthalung", "Phayao",
    "Phetchabun", "Phetchaburi", "Phichit", "Phitsanulok", "Phra Nakhon Si Ayutthaya", "Phrae", "Phuket",
    "Prachinburi", "Prachuap Khiri Khan", "Ranong", "Ratchaburi", "Rayong", "Roi Et", "Sa Kaeo",
    "Sakon Nakhon", "Samut Prakan", "Samut Sakhon", "Samut Songkhram", "Saraburi", "Satun", "Sing Buri",
    "Sisaket", "Songkhla", "Sukhothai", "Suphan Buri", "Surat Thani", "Surin", "Tak", "Trang", "Trat",
    "Ubon Ratchathani", "Udon Thani", "Uthai Thani", "Uttaradit", "Yala", "Yasothon",
];

const COUNTRIES = [
    "Thailand", "Cambodia", "China", "Hong Kong", "India", "Indonesia", "Japan", "Laos", "Malaysia",
    "Myanmar", "Philippines", "Singapore", "South Korea", "Taiwan", "Vietnam", "Australia",
    "United Kingdom", "United States",
];

// ฟิลด์ invoice ที่ถูก copy มาจากข้อมูลบริษัทเมื่อติ๊ก "Same as company information"
const COPIED_INVOICE_REFS = [
    "INV_Company_Name_Add",
    "Invoice_Address_Add",
    "inv_subdistrict",
    "inv_district",
    "inv_province",
    "inv_postcode",
    "inv_country",
    "INV_Branch_Add",
    "INV_Email_Add",
    "INV_Telephone_Number_Add",
];

// ฟิลด์ที่ส่งไป api.updateCompany (เหมือน dialog edit เดิม — ไม่ส่ง code)
const UPDATE_COMPANY_FIELDS = [
    "name", "company_address", "company_branch", "company_email", "company_tel",
    "inv_company_name", "inv_company_name_th", "inv_company_address", "inv_company_branch",
    "inv_company_email", "inv_company_tel", "inv_tax_id", "status",
    "company_address2", "subdistrict", "district", "province", "postcode", "country",
    "inv_company_address2", "inv_subdistrict", "inv_district", "inv_province", "inv_postcode", "inv_country",
];

export default {
    name: "EditCompanyDialog",
    props: {
        value: { type: Boolean, default: false },
        disabledStatus: { type: Boolean, default: false },
        company: { type: Object, default: null }, // แถวจากตาราง company
    },
    data: () => ({
        com: emptyCompany(),
        sameAs: false,
        statusall: ["ACTIVE", "INACTIVE"],
        provinceList: PROVINCES,
        countryList: COUNTRIES,
        emp_assign: [
            { name: "Manual", values: 1 },
            { name: "Auto-generated", values: 0 },
        ],
        emailRules: [
            (v) =>
                !v ||
                /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) ||
                "Please enter a valid email address",
        ],
        telRules: [(v) => !v || /^[+]?([0-9,-]+)$/.test(v) || "Please Input Number Only"],
        comcodeRules: [(v) => (!v || v.length > 6 ? "Please check that the Company Code" : true)],
    }),
    computed: {
        companyId() {
            return this.company ? Number(this.company.id) : null;
        },
        companyAddressLine() {
            const c = this.com;
            return [c.company_address, c.company_address2, c.subdistrict, c.district, c.province, c.postcode, c.country]
                .map((s) => (s || "").toString().trim())
                .filter(Boolean)
                .join(", ");
        },
        // ⚠️ รูปแบบนี้เป็นตัวอย่างสำหรับแสดงผลเท่านั้น
        employeeIdPreview() {
            const len = Math.max(parseInt(this.com.running_len, 10) || 1, 1);
            const next = Math.max(parseInt(this.com.running_next, 10) || 1, 1);
            const num = String(next).padStart(len, "0");
            const prefix = (this.com.id_prefix || "").trim();
            return prefix ? `${prefix}-${num}` : num;
        },
    },
    watch: {
        value(open) {
            if (open) this.load();
        },
        sameAs(val) {
            if (val) this.copyCompanyToInvoice();
        },
    },
    methods: {
        async load() {
            this.sameAs = false;
            const it = this.company || {};
            const com = emptyCompany();
            Object.keys(com).forEach((k) => {
                if (it[k] !== undefined && it[k] !== null) com[k] = it[k];
            });
            this.com = com;

            // Employee ID settings
            this.$showLoader();
            try {
                const resDoc = await api.fineDocRunningByModlue("Employee", this.companyId);
                const d = resDoc && resDoc.data;
                if (d) {
                    Object.assign(this.com, {
                        id_prefix: d.id_prefix || "",
                        running_year: d.running_year,
                        running_len: d.running_len,
                        running_next: d.running_next,
                        doc_status: d.check_doc_auto,
                    });
                }
            } catch (error) {
                console.error("EditCompanyDialog load doc running error:", error);
            } finally {
                this.$hideLoader();
            }
        },

        close() {
            this.$emit("input", false);
        },

        copyCompanyToInvoice() {
            const c = this.com;
            const t = (v) => (v || "").toString().trim();
            c.inv_company_name = t(c.name);
            c.inv_company_address = t(c.company_address);
            c.inv_company_address2 = t(c.company_address2);
            c.inv_subdistrict = t(c.subdistrict);
            c.inv_district = t(c.district);
            c.inv_province = t(c.province);
            c.inv_postcode = t(c.postcode);
            c.inv_country = t(c.country);
            c.inv_company_branch = t(c.company_branch);
            c.inv_company_email = t(c.company_email);
            c.inv_company_tel = t(c.company_tel);
        },

        // กันซ้ำ: ไม่นับแถวของบริษัทตัวเอง
        othersOnly(rows) {
            const list = Array.isArray(rows) ? rows : [];
            return list.filter((r) => Number(r.id) !== this.companyId);
        },

        // ---------------- Validation (เหมือน AddCompanyDialog step 2 + 3) ----------------
        checks() {
            const emailRegex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const telRegex = /^[+]?([0-9,-]+)$/;
            const c = this.com;
            const t = (v) => (v || "").toString().trim();

            const list = [
                // Company information
                { test: () => t(c.name) !== "", ref: "Company_Name_Add", msg: "Please Check Company Name Data" },
                { test: () => t(c.company_address) !== "", ref: "Company_Address_Add", msg: "Please check the company information again." },
                { test: () => t(c.country) !== "", ref: "country", msg: "Please select a country" },
                {
                    test: () => !t(c.company_email) || emailRegex.test(t(c.company_email)),
                    ref: "Company_Email_Add",
                    msg: "Please Check Company Email Data",
                },
                {
                    test: async () =>
                        !t(c.company_email) ||
                        this.othersOnly((await api.getCompanyCol(t(c.company_email), "company_email")).data).length === 0,
                    ref: "Company_Email_Add",
                    msg: "Email Duplicated, Please Check Email",
                },
                {
                    test: () => !t(c.company_tel) || telRegex.test(t(c.company_tel)),
                    ref: "Company_Telephone_Number_Add",
                    msg: "Please Check Telephone Number Data",
                },
                // Billing
                { test: () => t(c.inv_company_name) !== "", ref: "INV_Company_Name_Add", msg: "Please Check Company Name Data" },
                { test: () => t(c.inv_company_address) !== "", ref: "Invoice_Address_Add", msg: "Please check the invoice information again." },
                { test: () => t(c.inv_country) !== "", ref: "inv_country", msg: "Please check the invoice information again." },
                {
                    test: () => !t(c.inv_company_email) || emailRegex.test(t(c.inv_company_email)),
                    ref: "INV_Email_Add",
                    msg: "Please Check Company Email Data",
                },
                {
                    test: async () =>
                        !t(c.inv_company_email) ||
                        this.othersOnly((await api.getCompanyCol(t(c.inv_company_email), "inv_company_email")).data).length === 0,
                    ref: "INV_Email_Add",
                    msg: "Email Duplicated, Please Check Email",
                },
                {
                    test: () => !t(c.inv_company_tel) || telRegex.test(t(c.inv_company_tel)),
                    ref: "INV_Telephone_Number_Add",
                    msg: "Please Check Telephone Number Data",
                },
                { test: () => t(c.inv_tax_id) !== "", ref: "INV_Tax_ID_Add", msg: "Please Check Tax ID Data" },
            ];
            if (c.doc_status == 0) {
                list.push(
                    { test: () => Number(c.running_len) >= 1, ref: "Range", msg: "Please Check Range Data" },
                    { test: () => Number(c.running_next) >= 1, ref: "Next Running", msg: "Please Check Next Running Data" },
                );
            }
            return list;
        },

        async validate() {
            if (this.sameAs) this.copyCompanyToInvoice();
            for (const check of this.checks()) {
                if (!(await check.test())) {
                    if (this.sameAs && COPIED_INVOICE_REFS.includes(check.ref)) {
                        this.sameAs = false; // เปิดฟอร์ม invoice เต็มเพื่อให้แก้ช่องที่ผิดได้
                    }
                    this.fail(check.msg, check.ref);
                    return false;
                }
            }
            return true;
        },

        fail(msg, ref) {
            this.$emit("alert", { title: "Failed", message: msg, color: "text-h5 red--text text-center" });
            this.$nextTick(() => {
                const el = this.$refs[ref];
                if (el && el.focus) el.focus();
            });
        },

        // ---------------- Save (API เดิมเหมือนปุ่ม edit เดิม) ----------------
        async save() {
            this.$showLoader();
            try {
                if (!(await this.validate())) return;

                const c = this.com;
                const formData = new FormData();
                UPDATE_COMPANY_FIELDS.forEach((k) => {
                    const v = c[k];
                    formData.append(k, v === null || v === undefined ? "" : v.toString().trim());
                });

                const resUpdate = await api.updateCompany(this.companyId, formData);
                if (!(resUpdate.status == 200 || resUpdate.status == 201)) {
                    throw new Error(`updateCompany status ${resUpdate.status}`);
                }
                await api.updateDocRunningCom(this.companyId, {
                    module: "Employee",
                    id_prefix: c.id_prefix,
                    running_year: c.running_year,
                    running_len: c.running_len,
                    running_next: c.running_next,
                    doc_status: c.doc_status,
                });

                this.$emit("alert", {
                    title: "Success",
                    message: "Update data success",
                    color: "text-h5 green--text text-center",
                });
                this.$emit("saved");
                this.close();
            } catch (error) {
                console.error("EditCompanyDialog save error:", error);
                this.$emit("alert", {
                    title: "Failed",
                    message: "Update data Failed",
                    color: "text-h5 red--text text-center",
                });
            } finally {
                this.$hideLoader();
            }
        },
    },
};
